import { PAGES } from "@/internals/constants/pages";
import { StatsFormFields } from "./stats-block";

const structure = {
  page: PAGES.QR_EVENT,
  metaTitle: "_metaTitle",
  metaDescription: "_metaDescription",
  title: "_eventTitle",
  formFields: [
    {
      component: "Accordion",
      title: "_eventNameTitle",
      className: "qrForm",
      formFields: [
        {
          component: "Input",
          type: "text",
          placeholder: "_eventNamePlaceholder",
          errorMessage: [{ rule: "maxLength", message: "_eventNameMaxLength" }],
          name: "qrName",
          data_qa: "qr-event-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventThemePickerTitle",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "_eventThemePickerLabelPrimary",
          labelSecondary: "_eventThemePickerLabelSecondary",
          id: "qrEventThemePicker",
          name: "qrEventThemePicker",
          data_qa: "qr-event-theme-picker",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventInformationTitle",
      id: "qrEventInformation",
      className: "qrEventInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "_eventInformationImageLabel",
              id: "qrEventInformationImage",
              showEditor: "16/9",
              name: "logoUrl",
              data_qa: "qr-event-image-upload",
            },
          ],
        },
        {
          component: "Input",
          type: "text",
          name: "infoTitle",
          data_qa: "qr-event-title-input",
          label: "_eventInformationTitleLabel",
          placeholder: "_eventInformationTitlePlaceholder",
          errorMessage: [
            {
              rule: "minLength",
              message: "_eventInformationTitleMinLength",
            },
            {
              rule: "maxLength",
              message: "_eventInformationTitleMaxLength",
            },
          ],
        },
        {
          component: "Input",
          type: "text",
          name: "infoDescription",
          data_qa: "qr-event-description-input",
          label: "_eventInformationDescriptionLabel",
          placeholder: "_eventInformationDescriptionPlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_eventInformationDescriptionMaxLength",
            },
          ],
        },
        {
          component: "div",
          className: "button-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              name: "infoActionTitle",
              data_qa: "qr-event-button-text-input",
              label: "_eventInformationButtonLabel",
              placeholder: "_eventInformationButtonPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventInformationButtonMaxLength",
                },
              ],
            },
            {
              component: "Input",
              type: "text",
              name: "infoActionUrl",
              data_qa: "qr-event-button-url-input",
              label: "_eventInformationUrlLabel",
              placeholder: "_eventInformationUrlPlaceholder",
              errorMessage: [{ rule: "pattern", message: "_invalidUrlStart" }],
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventTimeTitle",
      className: "event-time",
      formFields: [
        {
          component: "EventDateTime",
          id: "eventDateTime",
          name: "eventDateTime",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventPreviewLocation",
      className: "qrEventLocation",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              className: "address",
              label: "_eventLocationAddressLabel",
              placeholder: "_eventLocationAddressPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventLocationAddressMaxLength",
                },
              ],
              name: "locationAddress",
              data_qa: "qr-event-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "Input",
                  type: "text",
                  label: "_eventLocationNumberLabel",
                  placeholder: "_eventLocationNumberPlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_eventLocationNumberMaxLength",
                    },
                  ],
                  name: "locationNumeration",
                  data_qa: "qr-event-numeration-input",
                },
                {
                  component: "Input",
                  type: "text",
                  label: "_eventLocationZipCodeLabel",
                  placeholder: "_eventLocationZipCodePlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_eventLocationZipCodeMaxLength",
                    },
                  ],
                  name: "locationPostalCode",
                  data_qa: "qr-event-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_eventLocationCityLabel",
              className: "city",
              placeholder: "_eventLocationCityPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventLocationCityMaxLength",
                },
              ],
              name: "locationCity",
              data_qa: "qr-event-city-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_eventLocationStateLabel",
              className: "state",
              placeholder: "_eventLocationStatePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventLocationStateMaxLength",
                },
              ],
              name: "locationState",
              data_qa: "qr-event-state-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_eventLocationCountryLabel",
              className: "country",
              placeholder: "_eventLocationCountryPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventLocationCountryMaxLength",
                },
              ],
              name: "locationCountry",
              data_qa: "qr-event-country-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventPreviewOrganizer",
      id: "qrEventOrganizerInformation",
      className: "qrEventOrganizerInformation",
      formFields: [
        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_eventOrganizerContactNameLabel",
              placeholder: "_eventOrganizerContactNamePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_eventOrganizerContactNameMaxLength",
                },
              ],
              name: "organizerName",
              data_qa: "qr-event-fullName-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_eventOrganizerPhoneLabel",
              placeholder: "_eventOrganizerPhonePlaceholder",
              errorMessage: [{ rule: "maxLength", message: "_eventOrganizerPhoneMaxLength" }],
              name: "organizerPhone",
              data_qa: "qr-event-phone-input",
            },
          ],
        },
        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_eventOrganizerEmailLabel",
              placeholder: "_eventOrganizerEmailPlaceholder",
              errorMessage: [{ rule: "pattern", message: "_invalidEmail" }],
              name: "organizerEmail",
              data_qa: "qr-event-email-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_eventOrganizerWebsiteLabel",
              placeholder: "_eventOrganizerWebsitePlaceholder",
              name: "organizerWebsite",
              errorMessage: [{ rule: "pattern", message: "_invalidUrlStart" }],
              data_qa: "qr-event-website-input",
            },
          ],
        },
        {
          component: "Input",
          customTag: "textarea",
          type: "text",
          label: "_eventOrganizerAboutUsLabel",
          placeholder: "_eventOrganizerAboutUsPlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_eventOrganizerAboutUsMaxLength",
            },
          ],
          name: "organizerAbout",
          data_qa: "qr-event-about-us-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_eventPreviewFacilities",
      className: "qrEventFacilities",
      formFields: [
        {
          component: "Picker",
          id: "qrEventFacilitiesPicker",
          multiple: true,
          className: "Picker__list-background",
          options: [
            "accommodation",
            "bar",
            "cafe",
            "child-friendly",
            "parking",
            "pet-friendly",
            "restaurant",
            "restrooms",
            "seating",
            "near-public-transport",
            "taxi",
            "wheelchair-access",
            "wifi",
          ],
          name: "facilities",
          data_qa: "qr-event-name-picker",
          selector: "icon",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_statsTitle",
      subtitle: "_statSubtitle",
      className: "qrForm",
      formFields: StatsFormFields(),
    },
  ],
  layoutTranslations: {
    eventPreviewTime: "_eventPreviewTime",
    eventPreviewTimeStart: "_eventPreviewTimeStart",
    eventPreviewTimeEnd: "_eventPreviewTimeEnd",
    eventPreviewTimeSchedule: "_eventPreviewTimeSchedule",
    eventPreviewAllDay: "_eventPreviewAllDay",
    eventPreviewLocation: "_eventPreviewLocation",
    eventPreviewOrganizer: "_eventPreviewOrganizer",
    eventPreviewFacilities: "_eventPreviewFacilities",
    eventPreviewOrganizerName: "_eventPreviewOrganizerName",
    eventPreviewOrganizerPhone: "_eventPreviewOrganizerPhone",
    eventPreviewOrganizerEmail: "_eventPreviewOrganizerEmail",
    eventPreviewOrganizerWebsite: "_eventPreviewOrganizerWebsite",
    eventPreviewOrganizerAbout: "_eventPreviewOrganizerAbout",
  },
};

export default structure;
